// extracted by mini-css-extract-plugin
var _1 = "hMpWQ";
var _2 = "qBR21";
var _3 = "vBpnN";
var _4 = "ijS2Q";
export { _1 as "is-inverse", _2 as "loading-spinner", _3 as "loading-spinner-small", _4 as "spin" }
